import { makeObservable } from 'shared/stores/core/make-observable';
import { SimpleMap } from 'shared/stores/core/SimpleMap';

export class ObservableMap extends SimpleMap {
  constructor () {
    super();
    this._rootState = makeObservable(this._rootState);
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/core/ObservableMap.js